






























import { Component, Vue, Watch } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import SubHeader from "@/components/SubHeader.vue";
import requestService from "@/service/requestService";
import { IppanSeibiService } from "@/service/IppanSeibiService";
import InspectionDetailContent from "@/components/InspectionDetailContent.vue";
import { Action, Getter } from "vuex-class";
import vuedraggable from "vuedraggable";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";

@Component({
  components: {
    Header,
    SubHeader,
    InspectionDetailContent,
    draggable: vuedraggable,
    ConfirmDialog
  }
})
export default class InspectionDetail extends Vue {
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  reqService: any;
  ippanSeibiService: IppanSeibiService;
  isReady: boolean = false;

  $refs!: {
    inspectionDetail: InspectionDetailContent;
    cancelDialog: ConfirmDialog;
  };


  /** 2024-05-02 nextage [START] */
  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;
  /** 2024-05-02 nextage [END] */

  @Getter("isUseIppanSeibi", { namespace: "FunctionSetting" })
  isUseIppanSeibi: boolean | null; // システム設定A 一般整備見積

  async created() {
    this.reqService = new requestService();
    this.ippanSeibiService = new IppanSeibiService();
    // 予約詳細は共通ルートガードで取得済み。
    this.isReady = true;
  }





  onCancel() {
    if (this.$refs.cancelDialog) {
      this.$refs.cancelDialog.onOpen();
    }
  }

  cancel() {
    const data = {
      sknUketsukeExtendsId: this.uketsukeExtendsId,
      uketsukeCd: this.uketsukeCd,
      yoyakuNo: this.yoyakuNo
    };
    this.reqService.saveCancel(data).then((res: any) => { // sendSocket:32車検中止
      this.$router.push({ name: "reservation" });
    });
  }

  disabledStart: boolean = true;
  startInspect() {
    this.$refs.inspectionDetail.startInspect();
  }
  setDisabledStart(val: boolean) {
    this.disabledStart = val;
  }
  finishStartInspect() {
    this.$router.push({ name: "carselection" });
  }
}
